export default "__VITE_ASSET__DvkUhkZ8__"